module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Falk er riktig-norming.56a9f4e5.mp3";